import { useEffect, useState } from 'react';

export const useSyncedCountFromStorage = (key: string): number | null => {
    // Because the backend takes time to reflect deletions,
    // we store the count in localStorage and sync it in the menu once the list is updated.

    const [count, setCount] = useState<number | null>(() => {
        const initial = localStorage.getItem(key);
        const parsed = Number(initial);
        return Number.isInteger(parsed) ? parsed : null;
    });

    useEffect(() => {
        const handleStorageChange = (event: StorageEvent) => {
            if (event.key === key) {
                const parsed = Number(event.newValue);
                setCount(Number.isInteger(parsed) ? parsed : null);
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, [key]);

    return count;
};
